/**
 * Callback `onLoad` do Prime Editor (Quill) nos campos de descrição de pesquisa/template.
 *
 * - Se o clipboard tiver `text/html`, o Quill já cola normalmente.
 * - Se só existir `text/plain` mas o conteúdo for um fragmento HTML (ex.: copiado de VS Code),
 *   intercepta e cola via clipboard do Quill para interpretar as tags.
 */
function looksLikeHtmlFragment(text) {
    const t = String(text).trim();
    if (t.length < 3 || !t.startsWith('<') || !t.includes('>')) return false;
    // Ex.: <p>, <div>, </span>, <!DOCTYPE é menos comum em trechos colados
    return /^<\/?[a-zA-Z][\w:.-]*/.test(t);
}

export function onSurveyDescriptionEditorLoad(quill) {
    if (!quill?.root) return;

    quill.root.addEventListener(
        'paste',
        (e) => {
            const cd = e.clipboardData;
            if (!cd) return;

            const html = cd.getData('text/html');
            if (html && html.trim()) return;

            const plain = cd.getData('text/plain') || '';
            if (!looksLikeHtmlFragment(plain)) return;

            e.preventDefault();
            e.stopImmediatePropagation();

            const range = quill.getSelection(true);
            if (range === null) return;

            const { index, length } = range;
            if (length > 0) {
                quill.deleteText(index, length, 'user');
            }
            try {
                quill.clipboard.dangerouslyPasteHTML(index, plain.trim());
            } catch (err) {
                console.warn('[survey editor] colar HTML falhou', err);
            }
        },
        true
    );
}
